import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Modal from "react-modal";
import axios from "axios";
import jwt_decode from "jwt-decode";
import * as MdIcons from "react-icons/md";
import * as RiIcons from "react-icons/ri";
import * as IoIcons from "react-icons/io";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { toast } from "react-toastify";
import "./company.css";
import {
  FETCH_COMPANIES_URL,
  CREATE_COMPANY_URL,
  UPDATE_COMPANY_URL,
  DELETE_COMPANY_URL,
} from "../../api/apiRoutes";

const Company = () => {
  const [isCreatingCompany, setIsCreatingCompany] = useState(false);
  const [isUpdatingCompany, setIsUpdattingCompany] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalDelete, setIsOpenModalDelete] = useState(false);

  const [company, setCompany] = useState({
    name: "",
    owner_firstname: "",
    owner_lastname: "",
    phone: "",
    phonecountrycode: "",
    email: "",
    password: "",
  });
  const [tableData, setTableData] = useState([]);
  const [companyId, setCompanyId] = useState("");

  const columnDefs = [
    { headerName: "Company ID", field: "companyId" },
    { headerName: "Email", field: "email" },
    { headerName: "Company Name", field: "name" },
    { headerName: "Owner Firstname", field: "owner_firstname" },
    { headerName: "Owner Lastname", field: "owner_lastname" },
    { headerName: "Phone Code", field: "phonecountrycode" },
    { headerName: "Phone", field: "phone" },
    {
      headerName: "Created on",
      field: "createdOn",
      cellRendererFramework: (params) => {
        const date = params.data.createdOn;
        if (!date) return "";
        return <button className="userCreatedBtn">{date}</button>;
      },
    },
    {
      headerName: "Role",
      field: "role",
      cellRendererFramework: (params) => {
        return params.data.role === "tag8superadmin" ? (
          <p style={{ color: "orange" }}>{params.data.role}</p>
        ) : params.data.role === "superadmin" ? (
          <p style={{ color: "green" }}>{params.data.role}</p>
        ) : params.data.role === "admin" ? (
          <p style={{ color: "black" }}>{params.data.role}</p>
        ) : (
          <p style={{ color: "black" }}>{params.data.role}</p>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      cellRendererFramework: (params) => (
        <>
          <button
            className="modal-edit btn"
            onClick={() => handleCompanyEdit(params.data)}
          >
            <MdIcons.MdEdit color="green" />
          </button>
          <button
            className="modal-edit btn"
            onClick={() => handleCompanyDelete(params.data.companyId)}
          >
            <MdIcons.MdDelete color="red" />
          </button>
        </>
      ),
    },
  ];

  const showToastAlert = (msg, type = "error") => {
    if (type === "error") {
      toast.error(msg, {
        position: "top-center",
      });
    } else if (type === "success") {
      toast.success(msg, {
        position: "top-center",
      });
    }
  };

  const handleCompanyEdit = (company) => {
    if (!company) {
      showToastAlert("Company not found.");
      return;
    }
    setCompany((prevState) => ({
      ...prevState,
      name: company.name,
      owner_firstname: company.owner_firstname,
      owner_lastname: company.owner_lastname,
      phone: company.phone,
      phonecountrycode: company.phonecountrycode,
      email: company.email,
    }));
    setCompanyId(company.companyId);
    setIsUpdattingCompany(true);
    handleModal();
  };

  const handleCompanyDelete = (id) => {
    if (!id) {
      showToastAlert("Company ID not found.");
      return;
    }
    setCompanyId(id);
    hanleModalDeleteOpenClose();
  };

  const handleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  const handleModalClose = () => {
    setIsOpenModal(!isOpenModal);
    setIsCreatingCompany(false);
    setIsUpdattingCompany(false);
    setCompany({
      name: "",
      owner_firstname: "",
      owner_lastname: "",
      phone: "",
      phonecountrycode: "",
      email: "",
      password: "",
    });
  };

  const hanleModalDeleteOpenClose = () => {
    setIsOpenModalDelete(!isOpenModalDelete);
  };

  const handleChange = (e) => {
    setCompany((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const isNumber = (value) => {
    if (!isNaN(value)) {
      return value;
    } else {
      showToastAlert("Country code and Phone number should be integers");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!company.name || company.name.trim() === "") {
        showToastAlert("Company name is required.");
        return;
      }

      if (!company.owner_firstname || company.owner_firstname.trim() === "") {
        showToastAlert("Owner's first name is required.");
        return;
      }

      if (!company.owner_lastname || company.owner_lastname.trim() === "") {
        showToastAlert("Owner's last name is required.");
        return;
      }

      if (!company.phonecountrycode || !isNumber(company.phonecountrycode)) {
        showToastAlert("Phone country code must be a valid number.");
        return;
      }

      if (!company.phone || !isNumber(company.phone)) {
        showToastAlert("Phone number must be a valid number.");
        return;
      }

      const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!company.email || !emailRegex.test(company.email)) {
        showToastAlert("Please enter a valid email address.");
        return;
      }

      if (
        isCreatingCompany &&
        (!company.password || company.password.trim().length < 8)
      ) {
        showToastAlert("Password must be at least 8 characters long.");
        return;
      }

      const postData = {
        name: company.name.trim(),
        owner_firstname: company.owner_firstname.trim(),
        owner_lastname: company.owner_lastname.trim(),
        phonecountrycode: company.phonecountrycode,
        phone: company.phone,
        email: company.email.trim(),
      };
      if (isUpdatingCompany) {
        await updateCompany(postData);
      }
      if (isCreatingCompany) {
        postData.password = company.password;
        await createCompany(postData);
      }
    } catch (error) {
      console.error("Error::handleSubmit :", error);
    }
  };

  // API IMPLEMENTATION:: Fetching Companies
  const fetchCopanies = async () => {
    try {
      // console.log("token: ");
      const response = await axios.post(
        FETCH_COMPANIES_URL,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      // console.log("response: ", response.data.data);
      if (response.data.data) {
        setTableData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };
  // API IMPLEMENTATION:: Create Company
  const createCompany = async (data) => {
    try {
      const response = await axios.post(CREATE_COMPANY_URL, data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
        },
      });
      // console.log("response: ", response.data)
      if (!response.data.isError) {
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      } else {
        showToastAlert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error("Error creating company:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };
  // API IMPLEMENTATION:: Update Company
  const updateCompany = async (data) => {
    try {
      if (!companyId) {
        showToastAlert("Company ID not found for update.");
        return;
      }
      const response = await axios.post(
        `${UPDATE_COMPANY_URL}/${companyId}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      // console.log("response: ", response.data);
      if (!response.data.isError) {
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating company:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };
  // API IMPLEMENTATION:: Delete Company
  const deleteCompany = async () => {
    try {
      if (!companyId) {
        showToastAlert("Company ID not found for delete.");
        return;
      }
      const response = await axios.post(
        `${DELETE_COMPANY_URL}/${companyId}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage?.getItem("token")}`,
          },
        }
      );
      console.log("response: ", response.data);
      if (!response.data.isError) {
        hanleModalDeleteOpenClose();
        showToastAlert(response.data.msg, "success");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error deleting company:", error);
      const errorMessage =
        error.response?.data?.msg || "An unknown error occurred.";
      showToastAlert(`${errorMessage}`);
    }
  };
  useEffect(() => {
    fetchCopanies();
  }, []);

  return (
    <>
      <button
        className="addBtn"
        onClick={() => {
          setIsCreatingCompany(true);
          handleModal();
        }}
      >
        Create Company
      </button>

      <div className="user-mgmnt-container">
        <div
          className="ag-theme-alpine"
          style={{
            height: "100%",
            width: "99.9%",
            paddingLeft: "1px",
            borderLeft: "1px solid #babfc7",
            borderRight: "1px solid #babfc7",
          }}
        >
          {!tableData.length ? (
            <div className="data-blank-div">
              <h3 className="data-blank-h3">No data found to display!</h3>
            </div>
          ) : (
            <AgGridReact
              columnDefs={columnDefs}
              rowData={tableData}
              defaultColDef={{ resizable: true, flex: 1 }}
              pagination={true}
              paginationPageSize={25}
              domLayout="autoHeight"
              isInverted={true}
            />
          )}
        </div>
      </div>

      {/* Modal */}
      <Modal
        className="register_modal"
        isOpen={isOpenModal}
        onRequestClose={handleModal}
      >
        <form
          action="post"
          className="userFormContainer"
          onSubmit={handleSubmit}
        >
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: ".5rem",
            }}
          >
            <RiIcons.RiUserAddFill />{" "}
            {isUpdatingCompany ? "Update" : "Register"} Company
          </h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
            }}
          >
            <label htmlFor="email">Name</label>
            <input
              required
              className="modalInput"
              type="text"
              name="name"
              id="name"
              value={company.name}
              onChange={handleChange}
            />

            <label htmlFor="email">Owner Firstname</label>
            <input
              required
              className="modalInput"
              type="text"
              name="owner_firstname"
              id="owner_firstname"
              value={company.owner_firstname}
              onChange={handleChange}
            />

            <label htmlFor="email">Owner Lastname</label>
            <input
              required
              className="modalInput"
              type="text"
              name="owner_lastname"
              id="owner_lastname"
              value={company.owner_lastname}
              onChange={handleChange}
            />

            <label>Country code and Phone number</label>
            <span
              style={{
                display: "flex",
                gap: ".2rem",
              }}
            >
              <input
                required
                className="cc-modalInput"
                type="text"
                name="phonecountrycode"
                id="cc"
                value={company.phonecountrycode}
                onChange={handleChange}
              />

              <input
                required
                className="modalInput"
                type="text"
                name="phone"
                id="phone"
                value={company.phone}
                onChange={handleChange}
              />
            </span>
          </div>

          <label htmlFor="email">Email</label>
          <input
            required
            className="modalInput"
            type="email"
            name="email"
            id="email"
            value={company.email}
            onChange={handleChange}
            // readOnly={isUpdatingCompany}
          />

          {isCreatingCompany && (
            <>
              <label htmlFor="password">Password</label>
              <input
                required
                className="modalInput"
                type="password"
                name="password"
                id="password"
                value={company.password}
                onChange={handleChange}
              />
            </>
          )}

          <span style={{ display: "flex", justifyContent: "space-evenly" }}>
            <input
              type="submit"
              value={isUpdatingCompany ? "Update" : "Register"}
              className="registerBtn"
            />

            <button onClick={handleModalClose} className="modal-closeBtn">
              Cancel
            </button>
          </span>
        </form>
      </Modal>
      {/* Delete Alert Modal */}
      <Modal
        className="register_modal"
        isOpen={isOpenModalDelete}
        onRequestClose={hanleModalDeleteOpenClose}
      >
        <div className="userFormContainer">
          <h2
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: ".5rem",
            }}
          >
            Are you sure? You want to detele.
          </h2>

          <span
            style={{ display: "flex", justifyContent: "center", gap: "0.5rem" }}
          >
            <button onClick={deleteCompany} className="registerBtn">
              Delete
            </button>
            <button
              onClick={hanleModalDeleteOpenClose}
              className="modal-closeBtn"
            >
              Cancel
            </button>
          </span>
        </div>
      </Modal>
    </>
  );
};

export default Company;
